import React, { useContext } from 'react'
import beginFormCss from 'styles/beginForm.module.scss'
import { ModalContext } from 'providers/Modal'
import { religionOptionsLib, motherTongueOptionsLib } from 'utils/commonLib'
import Dropdown from 'react-dropdown'
import 'styles/beginForm.scss'
import 'react-dropdown/style.css'
import 'styles/dropDownOverrrides.css'
import { trackButtonClick, trackOnBlur } from 'tracking/homepage'

const genderOptions = ['Woman', 'Man']
const defaultGenderOption = genderOptions[0]

const ageOptions = Array.from({ length: 54 }, (_, i) => i + 18).map(num =>
  String(num)
)

const religionOptions = domainReligion => [
  domainReligion,
  ...((domainReligion === 'Select' && religionOptionsLib) || []),
]

const motherTongueOptions = domainLanguage => [
  domainLanguage,
  ...((domainLanguage === 'Select' && motherTongueOptionsLib) || []),
]

const BeginForm = props => {
  const { setActive } = useContext(ModalContext)

  const handleClick = () => {
    setActive('register')
    trackButtonClick({
      fieldValue: `Lets Begin`,
    })
  }

  const handleChange = (name, e) => {
    trackOnBlur({
      fieldName: name,
      fieldValue: e.value,
    })
  }

  return (
    <div className="form-wrapper">
      <form className={beginFormCss.form}>
        <div className="form-row">
          <div className="form-group col-md-2 col-6">
            <label className="label" htmlFor="lookingFor">
              I'm looking for a
            </label>
            <Dropdown
              options={genderOptions}
              value={defaultGenderOption}
              placeholder={defaultGenderOption}
              onChange={e => handleChange('lookingFor', e)}
            />
          </div>
          <div className="form-group col-md-3 col-6">
            <label className="label">aged</label>
            <div className="ageWrap">
              <div className="ageFrom">
                <Dropdown
                  options={ageOptions}
                  value={ageOptions[2]}
                  placeholder={ageOptions[2]}
                  onChange={e => handleChange('ageFrom', e)}
                />
              </div>
              <div className="ageTo">to</div>
              <div className="ageUpto">
                <Dropdown
                  options={ageOptions}
                  value={ageOptions[7]}
                  placeholder={ageOptions[2]}
                  onChange={e => handleChange('ageUpto', e)}
                />
              </div>
            </div>
          </div>
          <div className="form-group col-md-2 col-6">
            <label className="label" htmlFor="religion">
              of religion
            </label>
            <Dropdown
              options={religionOptions(props.domainReligion)}
              value={props.domainReligion}
              placeholder={props.domainReligion}
              onChange={e => handleChange('religion', e)}
            />
          </div>
          <div className="form-group col-md-3 col-6">
            <label className="label" htmlFor="motherTounge">
              and mother tongue
            </label>
            <Dropdown
              options={motherTongueOptions(props.domainLanguage)}
              value={props.domainLanguage}
              placeholder={props.domainLanguage}
              onChange={e => handleChange('motherTounge', e)}
            />
          </div>
          <div className="form-group col-md-2 col-12 btnWrap">
            <label className="label btnLable" htmlFor="letsBeginBtn">
              &nbsp;
            </label>
            <button
              data-testid="lets_begin"
              type="button"
              onClick={handleClick}
              className="btn btn-primary form-control brand"
            >
              Let's Begin
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default BeginForm
